import {toast} from "react-toastify";
import React from "react";


function success(msg) {
  return toast.success(msg, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 5000
  });
}

function info(msg) {
  return toast.info(msg, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 5000
  });
}

function error(msg) {
  return toast.error(msg, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 15000
  });
}

function formatError(response) {

  let content = "";
  if (typeof response === "string") {
    content = generateErrorContent(response);

  } else {

    let message = "";
    let errors = response.errors || [];

    if (response.message && response.message.length > 0) {

      if (response.message.indexOf("NetworkError when attempting to fetch resource") >= 0 || response.message.indexOf("Connection refused") >= 0) {
        message = "Connection Error";
      }
      else {
        message = response.message;
      }

    } else {

      let hasErrorCode = response["error-code"] && response["error-code"].length > 0;
      if (hasErrorCode && response["error-code"] === "INTERNAL_SERVER_ERROR") {
        message = "Internal Server Error:";
      } else {
        message = "Error";
      }

    }

    content = generateErrorContent(message, errors);
  }
  return error(content);
}

function generateErrorContent(message, errors = []) {

  if (errors.length === 0)
    return generateErrorContent("Error", [message]);
  else
    return <div><h6>{message}</h6><br/>{generateErrorsFormat(errors)}</div>
}

function generateErrorsFormat(errors) {
  if (errors === undefined || errors.length === 0) return "";
  return <ul>
    {
      errors.map((error, index) => {
        return <li key={index}>
          {error}
        </li>
      })
    }
  </ul>
}

function warning(msg) {
  return toast.warn(msg, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 5000
  });
}

const ToastHelper = {
  success,
  info,
  error,
  warning,
  formatError
};

export default ToastHelper;
